var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 19.111,
    viewBox: "0 0 22 19.111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_13142",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 13142",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_12211",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 12211",
    d: "M2902.829,3923.082v5.911a2.209,2.209,0,0,1-2.223,2.193h-14.6a2.21,2.21,0,0,1-2.224-2.193v-5.911",
    transform: "translate(-2883.305 -3914.074)",
    fill: "none",
    stroke: "#2b2b2b",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_347",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 347",
    width: 3.53,
    height: 2.86,
    transform: "translate(8.235 8.923)",
    fill: "none",
    stroke: "#2b2b2b",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_12212",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 12212",
    d: "M2895.719,3915.91v-1.517c0-.316-.427-.571-.954-.571h-4.291c-.526,0-.953.255-.953.571v1.517",
    transform: "translate(-2882.62 -3913.821)",
    fill: "none",
    stroke: "#2b2b2b",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_12213",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 12213",
    d: "M2891.7,3924.621h-5.45c-1.614,0-2.9-.864-2.9-2.383v-3.05a2.207,2.207,0,0,1,2.222-2.193h15.556a2.207,2.207,0,0,1,2.222,2.193v3.05c0,1.52-1.286,2.383-2.9,2.383h-5.7",
    transform: "translate(-2883.348 -3914.826)",
    fill: "none",
    stroke: "#2b2b2b",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioIcon);
export default __webpack_public_path__ + "static/media/portfolio-icon.1c068aada52d8d68f73466e3b2c19add.svg";
export { ForwardRef as ReactComponent };